import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb350d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title sub-title" }, "申出者に関する項目", -1))
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { style: {"margin-left":"auto"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"padding":"0","margin":"0","width":"220px"} }, "メールアドレス【確認用】", -1))
const _hoisted_6 = { style: {"padding-left":"12px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" メールアドレス【確認用】を入力してください。 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 正しいメールアドレスの形式で入力してください。 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" メールアドレスと同じ値を入力してください。 ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "可能な限り、オンライン資料を公開しているサイトに掲載している問い合わせメールアドレスをご入力ください。当館で同一確認ができない場合はお申出をお受けできない場合がございます。", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "入力いただいた個人情報は、今回の申出手続きのみに使用し、他の目的には使用しません。", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 当館における個人情報の取り扱いについては ")
const _hoisted_13 = {
  href: "https://www.ndl.go.jp/jp/privacy/index.html",
  target: "_blank"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 「個人情報の取扱いについて」 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" をご覧ください。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
            name: '氏名',
            required: true,
            id: 'name',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.institution,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.institution) = $event)),
            name: '所属機関・企業・団体',
            required: true,
            id: 'institution',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.mailAddress,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.mailAddress) = $event)),
            name: 'メールアドレス',
            required: true,
            id: 'mailAddress',
            requiredCheck: _ctx.props.requiredCheck,
            type: 'email'
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("tr", null, [
                  _hoisted_5,
                  _createElementVNode("span", {
                    style: {"width":"100px"},
                    class: _normalizeClass(["label required", 'required-mailAddressCheck'])
                  }, "必須")
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_AppInput, {
                modelValue: _ctx.state.mailAddressCheck,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.mailAddressCheck) = $event)),
                label: "メールアドレス【確認用】",
                inputId: 'input-mailAddressCheck',
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.blurFlag = true)),
                type: 'email'
              }, null, 8, ["modelValue"]),
              (_ctx.state.mailAddressCheck === '' && (_ctx.blurFlag || _ctx.props.requiredCheck))
                ? (_openBlock(), _createBlock(_component_TextAlert, {
                    key: 0,
                    class: "errMsg-mailAddressCheck"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.mailAddressCheck && _ctx.emailCheck && (_ctx.blurFlag || _ctx.props.requiredCheck))
                ? (_openBlock(), _createBlock(_component_TextAlert, {
                    key: 1,
                    class: _normalizeClass('errMsg-emailCheck')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : (_ctx.mailAddressErrFlag && _ctx.blurFlag)
                  ? (_openBlock(), _createBlock(_component_TextAlert, {
                      key: 2,
                      class: "errMsg-mailAddressCheck"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.relation,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.relation) = $event)),
            name: '申出のオンライン資料と申出者の関係',
            description: '例：出版の責任者、出版した本人',
            required: true,
            id: 'relation',
            requiredCheck: _ctx.props.requiredCheck,
            width: "160px"
          }, null, 8, ["modelValue", "requiredCheck"])
        ])
      ]),
      _createElementVNode("ul", null, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("li", null, [
          _hoisted_12,
          _createElementVNode("a", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_DssIcon, { icon: 'action-share' })
          ]),
          _hoisted_15
        ])
      ])
    ])
  ], 64))
}